import {
  PaymentMethod,
  PricingModule,
  SportCenterBuyContractResponse,
  SportCenterPricing,
} from '@libs/entity-lib';
import { createReducer, on } from '@ngrx/store';
import * as fromActions from './pricing.actions';

export interface State {
  loading: boolean;
  plan: SportCenterPricing | null;
  modules: PricingModule[];
  paymentMethods: PaymentMethod[];
  error: any | null;
  buyResponse: SportCenterBuyContractResponse | null;
}

export const initialState: State = {
  loading: false,
  plan: null,
  modules: [],
  paymentMethods: [],
  error: null,
  buyResponse: null,
};

export const reducer = createReducer(
  initialState,
  on(fromActions.fetchAll, (state) => ({ ...state, loading: true })),
  on(fromActions.fetchAllSuccefully, (state, { plan, modules }) => ({
    ...state,
    plan,
    modules,
    loading: false,
  })),
  on(fromActions.fetchAllFailed, (state, { error }) => ({ ...state, error, loading: false })),

  on(fromActions.buyContract, (state) => ({ ...state, loading: true })),
  on(fromActions.buyContractSuccefully, (state, { response }) => ({
    ...state,
    buyResponse: response,
    loading: false,
  })),
  on(fromActions.buyContractFailed, (state, { error }) => ({ ...state, error, loading: false })),

  on(fromActions.checkPixStatusSuccess, (state, { response }) => ({
    ...state,
    buyResponse: state.buyResponse
      ? { ...state.buyResponse, ...response, qrCode: response.qrCode || state.buyResponse.qrCode }
      : response,
  })),
  on(fromActions.checkPixStatusFailed, (state, { error }) => ({ ...state, error })),

  on(fromActions.clearBuyResponse, (state) => ({ ...state, buyResponse: null })),

  on(fromActions.fetchPaymentMethodsSuccessfully, (state, { methods }) => ({
    ...state,
    paymentMethods: methods,
  })),
  on(fromActions.fetchPaymentMethodsFailed, (state, { error }) => ({ ...state, error }))
);
